import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getRoleListApi } from "../../api/roleApi";
import DateFormat from "../../utils/DateFormat";
import { FaEye, FaEdit } from "react-icons/fa";
import StatusBadge from "../Shared/StatusBadge";
import ActionIconButton from "../Shared/ActionIconButton";
import FullPageLoader from "../../common/FullPageLoader";
import EmptyState from "../../common/EmptyState";

const RoleList = () => {
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getRoleListApi(page, limit);
      if (response?.success === false) {
        setError(response?.message || "Failed to fetch roles");

        return;
      }

      const roleData = response?.data?.roles || response?.data || [];

      setRoles(Array.isArray(roleData) ? roleData : []);

      setTotalItems(
        response?.data?.totalItems || response?.data?.total || response?.totalItems || 0,
      );
    } catch (error) {
      console.error(error);

      setRoles([]);

      setError(error?.response?.data?.message || "Failed to fetch roles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [page]);

  if (loading) {
    return <FullPageLoader text="Loading roles..." />;
  }

  const totalPages = Math.ceil(totalItems / limit);

  return (
    <div className="container-fluid p-4 np-roles-page">
      {/* Header */}
      <div className="card p-3">
        {roles.length > 0 && <div className="d-flex justify-content-end align-items-center mb-3">
          <button type="button" className="btn btn-primary" onClick={() => navigate("/role/add")}>
            + Add Role
          </button>
        </div>}

        {/* Table */}
        <div className="card-body p-0">
          {roles.length === 0 ? (
            <div className="text-center">
              <EmptyState
                action={
                  <button type="button" className="btn btn-primary" onClick={() => navigate("/role/add")}>
                    + Add Role
                  </button>
                }
              />
            </div>
          ) : (
            <table className="table table-bordered table-hover">
              <thead className="bg-light">
                <tr>
                  <th className="text-dark fw-bold">#</th>
                  <th className="text-dark fw-bold">Role Name</th>
                  <th className="text-dark fw-bold">Status</th>
                  <th className="text-dark fw-bold">Created At</th>
                  <th className="text-dark text-center fw-bold">Action</th>
                </tr>
              </thead>

              <tbody>
                {roles.map((role, index) => (
                  <tr key={role?._id || index}>
                    <td>{(page - 1) * limit + index + 1}</td>

                    <td>
                      <p className="mb-0">{role?.name || role?.roleName || "-"}</p>
                    </td>

                    <td>
                      <StatusBadge status={role?.status} />
                    </td>

                    <td>
                      <DateFormat date={role?.createdAt} />
                    </td>

                    <td>
                      <div className="d-flex">
                        <ActionIconButton
                          icon={<FaEye />}
                          label="View"
                          variant="view"
                          onClick={() =>
                            navigate(`/role-view/${role._id}`, { state: { roleId: role._id } })
                          }
                        />

                        <ActionIconButton
                          icon={<FaEdit />}
                          label="Edit"
                          variant="edit"
                          onClick={() =>
                            navigate(`/role-edit/${role.name}`, {
                              state: { roleId: role._id },
                            })
                          }
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleList;
